"use client"

import { useState } from "react";
import { ClosePasswordIcon, OpenPasswordIcon } from "./setIcons";

export const useTogglePassword = () => {
  const [type, setType] = useState<"password" | "text">("password");
  const [icon, setIcon] = useState(<ClosePasswordIcon />);

  const toggle = () => {
    if (type === "password") {
      setType("text");
      setIcon(<OpenPasswordIcon />);
    } else {
      setType("password");
      setIcon(<ClosePasswordIcon />);
    }
  };

  return { type, icon, toggle };
};
